// app/shared/components/marketing/DifferentiatorCardComponent.tsx
'use client';

import React from 'react';

import { cn } from '@/lib/utils';

import { AccentColor } from '../../utils/accentColors';

interface DifferentiatorCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  accentColor: AccentColor;
  className?: string;
}

const accentBg: Record<AccentColor, string> = {
  teal: 'bg-teal-dark',
  purple: 'bg-purple-dark',
  yellow: 'bg-yellow',
  green: 'bg-green-dark',
  orange: 'bg-orange-dark',
};

const accentIconText: Record<AccentColor, string> = {
  teal: 'text-white',
  purple: 'text-white',
  yellow: 'text-black',
  green: 'text-white',
  orange: 'text-white',
};

export function DifferentiatorCardComponent({
  icon,
  title,
  description,
  accentColor,
  className,
}: DifferentiatorCardProps) {
  return (
    <div
      className={cn(
        'bg-beige-dark rounded-xl overflow-hidden shadow-md h-full flex flex-col',
        className
      )}
    >
      {/* Top accent bar */}
      <div className={cn('h-1.5', accentBg[accentColor])} />

      <div className="p-6 flex-1 flex flex-col">
        {/* Icon */}
        <div
          className={cn(
            'w-14 h-14 rounded-xl flex items-center justify-center mb-5',
            accentBg[accentColor]
          )}
        >
          <span className={accentIconText[accentColor]}>{icon}</span>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-black mb-3">{title}</h3>

        {/* Description */}
        <p className="text-gray-700 leading-relaxed flex-grow">{description}</p>
      </div>
    </div>
  );
}

